import _ from 'lodash'

export default {

  props: {
    alternative: {
      type: Boolean,
      default: false
    },
    featuredPosts: {
      type: Array,
      default: () => ([])
    },
    full: {
      type: Boolean,
      default: false
    },
    large: {
      type: Boolean,
      default: false
    },
    numberOfItems: {
      type: Number,
      default: 4
    },
    toryDiaryIDs: {
      type: Array,
      default: () => ([
        79,1210,   // dev
        68,       // torydiary
        6044,     // interviews
      ])
    },
    commentIDs: {
      type: Array,
      default: () => ([
        3,82,107,486,480, // dev
        69,       // columnists
        77,       // comment
        7086,     // sponsored
        2244,     // international
        71,       // think tanks
      ])
    },
    governmentIDs: {
      type: Array,
      default: () => ([
        13,35,20, // dev
        72,       // local gov
        70,       // parliament
        7746,     // public appointments
      ])
    },
  },

  computed: {
    excludedIds() {
      return _.map(this.featuredPosts, 'id')
    }
  }
}
